var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8468 14.028C12.0053 14.1866 12.0944 14.4015 12.0944 14.6257C12.0944 14.8499 12.0053 15.0648 11.8468 15.2234C11.6883 15.3819 11.4733 15.4709 11.2491 15.4709C11.025 15.4709 10.81 15.3819 10.6515 15.2234L5.02649 9.59836C4.94783 9.51997 4.88541 9.42683 4.84283 9.32427C4.80024 9.22171 4.77832 9.11175 4.77832 9.0007C4.77832 8.88965 4.80024 8.77969 4.84283 8.67713C4.88541 8.57458 4.94783 8.48143 5.02649 8.40304L10.6515 2.77804C10.81 2.61954 11.025 2.53049 11.2491 2.53049C11.4733 2.53049 11.6883 2.61954 11.8468 2.77804C12.0053 2.93655 12.0944 3.15154 12.0944 3.3757C12.0944 3.59987 12.0053 3.81485 11.8468 3.97336L6.82016 9L11.8468 14.028Z",
    fill: "#61B347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.db5b97be754cf85c5d64193144d8e68b.svg";
export { ForwardRef as ReactComponent };